import cmsApi from '@src/services/cms-api';

const Service = {
  getList: () => cmsApi.getArticleList({ categoryId: 7520, pageNum: 1, pageSize: 100, moreInfo: 1, api: 'https://www.xishanju.com/api.php' })
};
export default Service;
